import React from "react";


function Header() {

  return (
   <header className="header">
<a href="#home" className="logo">MUHAMMAD <span>DILSHAIR</span></a>

<i className="box box-menu" id="menu-icon"></i>
<nav className="navbar">
<a href="#home">Home</a>
<a href="#about">About</a>
<a href="#services">Services</a>
<a href="#skills">Skills</a>
<a href="#projects">Projects</a>
<a href="#contact">Contact</a>
</nav>
    </header>
  );
}

export default Header;
